import Login from './Login';
import Logout from './Logout';
import Header from '../components/AppHeader';
import Sidebar from '../components/Sidebar';
import Footer from '../components/AppFooter';
import Dashboard from './Dashboard';
import UserConfirm from './UserConfirm';
import UserResetPassword from './UserResetPassword';
import Register from './Register';
import MyProperties from './MyProperties';
import SearchProperties from './SearchProperties';
import SavedProperties from './SavedProperties';
import MyCalendar from './MyCalendar';
import Messages from './Messages';
import MyProfile from './MyProfile';
import Notifications from './Notifications';
import Checkout from './Checkout';
import Property from './Property';
import Message from './Message';
import ViewProperty from './ViewProperty';
import StyleGuide from './StyleGuide';
import Terms from './TermsConditions';
import Privacy from './PrivacyPolicy';
import Cookie from './CookiePolicy';
import NewMessageThread from './NewMessageThread';
import OwnerValidationConfirmation from './OwnerValidationConfirmation';

export default [
    {
        path: '/',
        name: 'dashboard',
        components: {
            header: Header,
            sidebar: Sidebar,
            default: Dashboard,
            footer: Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/my-properties',
        name: 'my-properties',
        components: {
            header: Header,
            sidebar: Sidebar,
            default: MyProperties,
            footer: Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/saved-properties',
        name: 'saved-properties',
        components: {
            header: Header,
            sidebar: Sidebar,
            default: SavedProperties,
            footer: Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/search-properties/:page?',
        name: 'search-properties',
        components: {
            header: Header,
            sidebar: Sidebar,
            default: SearchProperties,
            footer: Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/my-calendar',
        name: 'my-calendar',
        components: {
            header: Header,
            sidebar: Sidebar,
            default: MyCalendar,
            footer: Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/messages/new/:toType/:toId?/:support?',
        name: 'new-message-thread',
        components: {
            header: Header,
            sidebar: Sidebar,
            default: NewMessageThread,
            footer: Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/messages/page/:page?',
        alias: '/messages',
        name: 'messages',
        components: {
            header: Header,
            sidebar: Sidebar,
            default: Messages,
            footer: Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/messages/:threadId/:page?',
        name: 'message',
        components: {
            header: Header,
            sidebar: Sidebar,
            default: Message,
            footer: Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/notifications/:page?',
        name: 'notifications',
        components: {
            header: Header,
            sidebar: Sidebar,
            default: Notifications,
            footer: Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/my-profile/:sectionName?/:sectionId?',
        name: 'my-profile',
        components: {
            header: Header,
            sidebar: Sidebar,
            default: MyProfile,
            footer: Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/styleguide',
        name: 'styleguide',
        components: {
            header: Header,
            sidebar: Sidebar,
            default: StyleGuide,
            footer: Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/property/:id/edit',
        name: 'property',
        components: {
            header: Header,
            sidebar: Sidebar,
            default: Property,
            footer: Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/property/:id',
        name: 'view-property',
        components: {
            header: Header,
            sidebar: Sidebar,
            default: ViewProperty,
            footer: Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'login',
        components: {
            header: Header,
            default: Login,
            footer: Footer
        }
    },
    {
        path: '/logout',
        name: 'logout',
        components: {
            header: Header,
            default: Logout,
            footer: Footer
        }
    },
    {
        path: '/register',
        name: 'register',
        components: {
            header: Header,
            default: Register,
            footer: Footer
        }
    },
    {
        path: '/checkout/:propertyId?',
        name: 'checkout',
        components: {
            header: Header,
            default: Checkout,
            footer: Footer
        },
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/user/confirm',
        name: 'confirm-user',
        components: {
            header: Header,
            default: UserConfirm,
            footer: Footer
        }
    },
    {
        path: '/user/password-reset',
        name: 'password-reset',
        components: {
            header: Header,
            default: UserResetPassword,
            footer: Footer
        }
    },
    {
        path: '/terms-conditions',
        name: 'terms-conditions',
        components: {
            header: Header,
            default: Terms,
            footer: Footer
        }
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        components: {
            header: Header,
            default: Privacy,
            footer: Footer
        }
    },
    {
        path: '/cookie-policy',
        name: 'cookie-policy',
        components: {
            header: Header,
            default: Cookie,
            footer: Footer
        }
    },
    {
        path: '/owner/:ownerId/verify/:confirmationCode',
        name: 'owner-validation-confirmation',
        components: {
            header: Header,
            default: OwnerValidationConfirmation,
            footer: Footer
        }
    }
];
